export const fa = {
  // Login Page
  welcomeMessage: 'خوش‌امدید به',
  welcomeEmoji: '👋🏻',
  loginSubtitle: 'لطفاً وارد حساب کاربری خود شوید و ماجراجویی را آغاز کنید',
  emailOrUsername: 'ایمیل یا نام کاربری',
  emailPlaceholder: 'ایمیل یا نام کاربری خود را وارد کنید',
  password: 'رمز عبور',
  passwordPlaceholder: '············',
  rememberMe: 'مرا به خاطر بسپار',
  forgotPassword: 'رمز عبور را فراموش کرده‌اید؟',
  login: 'ورود',
  loggingIn: 'در حال ورود...',
  newUser: 'کاربر جدید هستید؟',
  createAccount: 'حساب کاربری ایجاد کنید',
  or: 'یا',
  characterImage: 'تصویر کاراکتر',
  mask: 'ماسک',

  // Navigation
  home: 'خانه',
  about: 'درباره',
  inbox: 'صندوق پیام‌ها',
  assistants: 'دستیار‌ها',
  knowledgeBases: 'پایگاه‌های دانش',
  personalAssistant: 'دستیار شخصی',

  // User Dropdown
  userAlt: 'جان دو',
  userName: 'جان دو',
  userEmail: 'admin@vuexy.com',
  myProfile: 'پروفایل من',
  settings: 'تنظیمات',
  pricing: 'قیمت‌گذاری',
  faq: 'سوالات متداول',
  logout: 'خروج',

  // Mode Dropdown
  lightMode: 'روشن',
  darkMode: 'تاریک',
  systemMode: 'سیستم',
  modeTooltip: 'حالت',

  // Footer
  copyrightText: 'ساخته شده با',
  copyrightBy: 'توسط',
  companyName: 'نقش آوا',
  licenseLink: 'مجوز',
  moreThemesLink: 'قالب‌های بیشتر',
  documentationLink: 'مستندات',
  supportLink: 'پشتیبانی',

  // 401  ٍError
  unauthorized401: 'خطای احراز هویت',

  // 404 Page
  pageNotFoundTitle: 'صفحه پیدا نشد ⚠️',
  pageNotFoundMessage: 'صفحه‌ای که به دنبال آن هستید را نتوانستیم پیدا کنیم.',
  backToHome: 'بازگشت به خانه',
  notFoundImageAlt: 'تصویر خطای 404',

  // Dashboard Pages
  homePage: 'صفحه اصلی!',
  aboutPage: 'صفحه درباره ما!',

  // Register Page
  registerTitle: 'ماجراجویی از اینجا شروع می‌شود 🚀',
  registerSubtitle: 'مدیریت اپلیکیشن خود را آسان و سرگرم‌کننده کنید!',
  username: 'نام کاربری',
  usernamePlaceholder: 'نام کاربری خود را وارد کنید',
  registerEmail: 'ایمیل',
  registerEmailPlaceholder: 'ایمیل خود را وارد کنید',
  agreeToTerms: 'من با',
  privacyPolicyTerms: 'قوانین حریم خصوصی و شرایط',
  signUp: 'ثبت نام',
  alreadyHaveAccount: 'قبلاً حساب کاربری دارید؟',
  signInInstead: 'وارد شوید',
  signing: 'در حال ورود...',

  // Validation Messages
  usernameMinLength: 'نام کاربری باید حداقل ۳ کاراکتر باشد',
  usernameMaxLength: 'نام کاربری باید کمتر از ۲۰ کاراکتر باشد',
  emailRequired: 'ایمیل الزامی است',
  emailInvalid: 'لطفاً یک ایمیل معتبر وارد کنید',
  passwordMaxLength: 'رمز عبور باید کمتر از ۵۰ کاراکتر باشد',
  agreeToTermsRequired: 'شما باید قوانین و شرایط را بپذیرید',
  passwordMinLength: 'رمز عبور باید حداقل 8 کاراکتر داشته باشد.',
  passwordMustContainUppercase: 'رمز عبور باید شامل حروف انگلیسی بزرگ باشد.',
  passwordMustContainLowercase: 'رمز عبور باید شامل حروف انگلیسی کوچک باشد.',
  passwordMustContainNumber: 'رمز عبور باید شامل حداقل یک عدد باشد.',
  passwordMustContainSpecialChar: 'رمز عبور باید شامل حداقل یک کاراکتر خاص مانند @$& باشد.',
  questionRequired: 'سوال الزامی است',
  answerRequired: 'پاسخ الزامی است',
  messageCannotBeEmpty: 'پیام نباید خالی باشد',
  titleRequired: 'عنوان الزامی است',
  knowledgeBaseRequired: 'لطفاً یک پایگاه دانش انتخاب کنید',
  descriptionRequired: 'توضیح الزامی است',
  linkRequired: 'لینک الزامی است',
  atLeastOneQuestionRequired: 'حداقل یک سوال اضافه کنید',
  fileRequired: 'فایل الزامی است',

  // Register Page Metadata
  registerPageTitle: 'ثبت نام',
  registerPageDescription: 'حساب کاربری خود را ایجاد کنید و ماجراجویی را آغاز کنید',

  // Personal Assistant Page Metadata
  personalAssistantPageTitle: 'دستیار شخصی',
  personalAssistantPageDescription: 'دستیار هوشمند شخصی شما برای کمک در انجام کارهای روزانه و ارائه پیشنهادات هوشمند',

  // Metadata
  metadataTitle: 'آینو - قالب داشبورد ادمین Next.js با MUI',
  metadataDescription:
    'آینو - قالب داشبورد ادمین Next.js با MUI - دوستانه‌ترین قالب برای توسعه‌دهندگان و کاملاً قابل تنظیم که بر اساس MUI v5 ساخته شده است.',

  //fileinput
  fileInputDefaultTitle: 'فایل خود را اینجا رها کنید یا برای انتخاب کلیک کنید',
  fileInputDefaultDescription: 'فقط یک فایل قابل آپلود است',
  tagInputPlaceHolder: 'بنویسید و دکمه Enter را بزنید',
  textUploadHelper:
    'فایل CSV باید شامل ستون‌های question، answer و tags باشد. {br} (مجموع سوال و پاسخ را در ۱۰۲۴ کاراکتر محدود کنید)',

  //shared

  setting: 'تنظیمات',
  cancel: 'لغو',
  agreed: 'تایید',
  delete: 'حذف',
  yesOfCourse: 'بله مطمئنم',
  makeChanges: 'ذخیره تغییرات',
  agent: 'دستیار',
  detail: 'مشخصات',
  back: 'بازگشت',
  submit: 'ثبت',
  qa: 'پرسش و پاسخ',
  imageFile: 'فایل تصویری',
  question: 'سوال',
  answer: 'پاسخ',
  nextStep: 'مرحله بعد',
  text: 'متن',
  website: 'وبسایت',
  moreSettings: 'تنظیمات بیشتر',
  documentation: 'مستندات',
  headerTitle: 'عنوان هدر',
  headerBackground: 'پس‌زمینه هدر',
  messageTitle: 'عنوان پیام',
  messageTextColor: 'رنگ متن پیام',
  messageBackground: 'پس‌زمینه پیام',
  footerBackground: 'پس‌زمینه فوتر',
  chatBackground: 'پس‌زمینه چت',
  floatingButtonPosition: 'موقعیت دکمه شناور',
  floatingButtonIcon: 'آیکون دکمه شناور',
  shouldUseAI: 'استفاده از هوش مصنوعی',
  shouldUseAIHint: 'با غیرفعال‌کردن این گزینه، پاسخ‌گویی به پیام‌های پشتیبانی بر عهده شماست.',
  buttonColor: 'رنگ دکمه',
  bottomLeft: 'پایین چپ',
  bottomRight: 'پایین راست',
  title: 'عنوان',
  status: 'وضعیت',
  tags: 'برچسب ها',

  //Agents
  noAgentFound:
    'دستیارها، <boldLine>چت‌بات‌های هوشمند</boldLine> شما هستن! اون‌ها بر اساس نیازها و <boldLine>داده‌های خاص شما</boldLine> طراحی و به‌راحتی شخصی‌سازی می‌شن. {br} با اتصال به یک یا چند پایگاه دانش اختصاصی، دستیارها یاد می‌گیرن و با ارائه پاسخ‌های دقیق و هدفمند، تجربه‌ای سفارشی برای شما ایجاد می‌کنن. وقتشه که اولین دستیار خودتون رو بسازین!',
  createAgent: 'ساخت دستیار',
  createNewAgent: 'ساخت دستیار جدید',
  connectToKnowledgeBase: 'اتصال به پایگاه دانش',
  learnAndCreateAgent: 'یادگیری و ساخت دستیار',
  yourChatBotName: 'نام چت بات شما :',
  chatBotNameSample: 'مثال : چت بات سایت ...',
  textFile: 'فایل متنی',
  knowledgeBaseCratingHelper:
    'در این مرحله، یک پایگاه دانش به نام Default Knowledge Base برای شما ایجاد و داده شما از طریق فرم زیر به اون اضافه می‌شه و به این دستیار متصل می‌شه. یادتون باشه، هر زمان بخواید می‌تونید داده‌های جدید و متنوعی به این پایگاه دانش اضافه کنید.',
  acceptableFormatsForTextfile: 'فرمت‌های قابل قبول: pdf، doc، docx، xls، xlsx، md',
  acceptableFormatsForImage: 'فرمت‌های قابل قبول: jpg، jpeg، png',
  selectedTextForLearning: 'متن مورد نظر برای یادگیری را وارد کنید',
  dataName: 'عنوان :',
  dataNameExample: 'مثال : داده سایت ...',
  websiteUrl: 'آدرس وب سایت :',
  websiteUrlSample: 'مثال : چت بات سایت ...',
  whatsHappensWhenShowSourceBeTrue:
    'اگر گزینه «نمایش منابع» در تنظیمات دستیار فعال باشه، در صورت استفاده از این داده، آدرس اینترنتی فوق به عنوان منبع به کاربر نمایش داده می‌شه.',
  singePageUrl: 'آدرس تک صفحه',
  mapPageUrl: 'آدرس سایت مپ',
  singleLink: 'لینک تکی ',
  mapSite: 'سایت مپ',
  selectLinkType: 'نوع لینک داده خود را مشخص کنید',
  checkLink: 'بررسی لینک',
  downloadCsvSample: 'دانلود نمونه',
  csvFileCaption: 'فایل Excel باید شامل ستون‌های question، answer باشد.',
  limitChar: '(مجموع سوال و پاسخ را در ۱۰۲۴ کاراکتر محدود کنید)',
  uploadCsvFile: 'آپلود فایل CSV',
  dataGroup: 'داده گروهی',
  addQA: 'اضافه کردن سوال',

  //KnowledgeBase
  createNew: 'ایجاد پایگاه دانش جدید',
  KnowledgeBaseName: 'نام پایگاه دانش',
  thisActionDeleteKnowledgeBase: 'این عملیات پایگاه دانش و تمام دستیار های متصل به آن را حذف میکند.',
  editDataGroup: 'ویرایش گروه داده',
  dataGroupId: 'کلید گروه داده  :',
  apiSettings: 'تنظیمات API',
  moreAboutAgentApi: 'درباره API دستیار بیشتر بدانید',
  addToSelectedKnowledgeBase: 'افزودن داده به پایگاه دانش انتخابی',
  selectKnowledgeBaseFirst: 'ابتدا یک پایگاه دانش انتخاب کنید',
  searchInTitles: 'جستجو در عناوین...',
  characterCount: 'تعداد کاراکتر',
  synchronize: 'همگام‌سازی',
  noDataFound: 'داده‌ای موجود نیست',
  description: 'توضیحات',
  path: 'مسیر',
  type: 'نوع',
  failed: 'ناموفق',
  inProgress: 'در حال انجام',
  new: 'جدید',
  successful: 'موفق',
  content: 'محتوا',

  // Personal Assistant Feature
  startNewChat: 'شروع گفتگوی جدید',
  searchContacts: 'جستجوی مخاطبین',
  selectContactToStart: 'برای شروع گفتگو یک مخاطب را انتخاب کنید.',
  online: 'آنلاین',
  away: 'غایب',
  doNotDisturb: 'مزاحم نشوید',
  offline: 'آفلاین',
  twoStepVerification: 'تأیید دو مرحله‌ای',
  notification: 'اعلان',
  inviteFriends: 'دعوت از دوستان',
  deleteAccount: 'حذف حساب کاربری',
  typeAMessage: 'پیام خود را بنویسید',
  chooseCollection: 'پایگاه دانش خود را انتخاب کنید',
  send: 'ارسال',
  selectContact: 'انتخاب مخاطب',
  action: 'عملیات',
  deleteConfirm: 'آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟',
  yesDelete: 'بله، حذف کن',
  apiKey: 'کلید API',
  baseUrl: 'آدرس پایه',
  showSource: 'نمایش منابع',
  apiKeyRequired: 'کلید API مورد نیاز است',
  baseUrlRequired: 'آدرس پایه مورد نیاز است',
  invalidUrl: 'باید یک آدرس معتبر باشد',
  atLeastOneFieldRequired: 'حداقل یک فیلد مورد نیاز است',
  apiError: 'به‌روزرسانی تنظیمات ناموفق بود',
  error: 'خطا',
  balance: 'موجودی',
  yourBalance: 'موجودی شما:',
  passwordsMustNotMatch: 'رمز جدید نباید با رمز قبلی یکسان باشد',
  passwordsMustMatch: 'رمز عبور و تکرار آن باید یکسان باشند',
  changePassword: 'تغییر رمز عبور',
  currentPassword: 'رمز عبور فعلی',
  repeatPassword: 'تکرار رمز عبور',
  name: 'نام',
  PublishAssistant: 'انتشار دستیار',
  Step1: 'برای قرار دادن این دستیار در وبسایت خود، کد زیر را داخل',
  BodyTag: '<body>',
  Step1End: 'قرار دهید.',
  Step2: 'پس از اضافه کردن، دستیار به‌صورت خودکار روی صفحه شما لود شده و آماده تعامل با کاربران خواهد بود.',
  Step3: 'برای بهترین عملکرد، می‌توانید آن را در پایین HTML خود (قبل از بسته شدن',
  BodyTagEnd: '</body>',
  Step3End: ') قرار دهید.',
  agentWelcomeMessage: 'پیام خوش‌آمدگویی',
  collectionTitle: 'عنوان پایگاه دانش',
  color: 'رنگ',
  logo: 'لوگو',
  avatar: 'آواتار',
  save: 'ذخیره',
  welcomeMessageMin: 'پیام خوش‌آمدگویی باید حداقل ۵ کاراکتر باشد',
  collectionTitleMin: 'عنوان پایگاه دانش باید حداقل ۲ کاراکتر باشد',
  colorInvalid: 'رنگ وارد شده نامعتبر است',
  reset: 'بازنشانی',
  savedSuccessfully: 'با موفقیت ذخیره شد',
  saveFailed: 'ذخیره‌سازی ناموفق بود',
  customize: 'سفارشی‌سازی',
  publish: 'انتشار',
  addAgent: 'افزودن دستیار',
  collection: 'پایگاه دانش',
  promptTemplate: 'قالب پرامپت',
  view: 'مشاهده',
  na: 'موجود نیست',
  agentName: 'نام دستیار',
  isPreviouslyUsedPassword:
    'لطفا کلمه‌ی عبور دیگری را انتخاب کنید. این کلمه‌ی عبور پیشتر توسط شما استفاده شده‌است و تکراری می‌باشد.',
  somethingWentWrong: 'مشکلی پیش آمده، بعداً دوباره تلاش کنید.',
  invalidEmailOrPassword: 'ایمیل یا رمز عبور نامعتبر است.',
  KnowledgeBaseSource: 'منبع پایگاه دانش',

  //menu

  chatBot: 'چت‌بات',
  Agent: 'دستیار',
  UnAnsweredQuestion: 'سؤالات بی‌پاسخ',
  PrivateRag: 'دستیار خصوصی',
  'Personal Assistant': 'دستیار شخصی',
  Setting: 'تنظیمات',
  ContentCreator: 'تولیدکننده محتوا',
  Inbox: 'صندوق ورودی',
  Token: 'توکن',
  KnowledgeBase: 'پایگاه دانش',
  profile: 'پروفایل',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  phoneNumber: 'شماره تلفن',
  phoneNumberInvalid: 'شماره تلفن نامعتبر است',
  countryCodeLabel: 'کد کشور',
  countryCodeHelper: 'کد پیش‌شماره کشور را انتخاب کنید',
  countryIran: 'ایران',
  countryCanada: 'کانادا',
  countryUnitedStates: 'ایالات متحده آمریکا',
  countryUnitedKingdom: 'بریتانیا',
  countryGermany: 'آلمان',
  countryFrance: 'فرانسه',
  countryJapan: 'ژاپن',
  allowedFileTypes: 'فایل‌های مجاز: JPG، GIF یا PNG',
  fileSizeLimit: 'حجم فایل باید کمتر از ۸۰۰ کیلوبایت باشد.',
  uploadNewPhoto: 'بارگذاری عکس جدید',
  unansweredQuestions: 'سوالات پاسخ‌داده‌نشده',
  noUnansweredQuestions: 'سوالی برای پاسخ دادن وجود ندارد',
  writeAnswerOfFollowingQuestion: 'جواب سوال زیر را بنویس:',
  pleaseEnterDesiredAnswer: 'لطفاً پاسخ موردنظر را وارد کنید',

  usageLimitMessage: 'سقف استفاده از این قابلیت به پایان رسیده است.',
  hasNoPlan: 'اشتراک فعال ندارین!',
  purchaseSubscriptionToContinue: 'برای استفاده دوباره از آینو اشتراک تهیه کنین',
  active: 'فعال',
  notActive: 'غیر فعال',

  Answered: 'پاسخ داده شد',

  //transactions
  goToPayment: 'رفتن به پرداخت',
  price: 'مبلغ',
  continuePayment: 'ادامه به پرداخت',
  amountMustBeGreaterThan100000: 'مبلغ باید بیشتر از ۱،۰۰۰٬۰۰۰ باشد',
  selectPackageFirst: 'لطفاً ابتدا یک اشتراک را انتخاب کنید',

  recentTransactions: 'تراکنش‌های اخیر',
  yourLatestFinancialActivities: 'آخرین فعالیت‌های مالی شما',
  newest: 'جدیدترین',
  oldest: 'قدیمی‌ترین',
  latest: 'آخرین',
  noRecentTransactionsFound: 'هیچ تراکنش اخیرى یافت نشد.',
  transactionDetails: 'جزئیات تراکنش',
  share: 'اشتراک‌گذاری',
  export: 'صادرات',
  paymentSuccessfullyCompleted: 'پرداخت با موفقیت انجام شد',
  fundsTransferredSecurely: 'مبالغ با امنیت منتقل شدند',
  paymentPending: 'پرداخت در انتظار',
  paymentIsPending: 'پرداخت شما در حال پردازش است!',
  paymentUnsuccessful: 'پرداخت ناموفق',
  fundsNotTransferred: 'مبالغ منتقل نشدند',
  userInformation: 'اطلاعات کاربر',
  cardDeposit: 'واریز کارت',
  sourceCardNumber: 'شماره کارت مبدا',
  destinationCardNumber: 'شماره کارت مقصد',
  paymentProvider: 'ارائه‌دهنده پرداخت',
  transactionId: 'شناسه تراکنش',
  referenceNumber: 'شماره مرجع',
  explanation: 'توضیحات',
  chatbotChargeMessage: 'این هزینه برای پرسیدن سوال زیر از چت‌بات اعمال شد:',
  currentBalanceAfterTransaction: 'موجودی فعلی پس از تراکنش',
  date: 'تاریخ',
  wallet: 'کیف پول',
  transactions: 'تراکنش ها',
  chargeYourAccount: 'شارژ حساب',
  totalBalance: 'موجودی کل',
  BadUserNameError: 'نام کاربری وارد شده معتبر نیست.',
  DuplicateUserName: 'نام کاربری هم‌اکنون مورد استفاده است.',
  DuplicateEmail: 'نام کاربری هم‌اکنون مورد استفاده است.',
  aiModelRequired: 'لطفاً یک مدل هوش مصنوعی انتخاب کنید.',
  aiModel: 'مدل هوش مصنوعی',
  backToWallet: ' بازگشت به کیف پول',
  backToPlans: 'بازگشت به اشتراک‌ها',
  planName: 'نام اشتراک',

  filters: 'فیلترها',
  loading: 'در حال بارگذاری...',
  agentPlaceholder: 'انتخاب دستیار',
  statusPlaceholder: 'انتخاب وضعیت',
  openChat: 'چت‌های باز',
  closeChat: 'چت‌های بسته',
  humanSupport: 'پشتیبانی انسانی',
  apply: 'اعمال',
  connectHumanSupport: 'ارتباط با پشتیبانی',
  all: 'همه',
  seeConversation: 'مشاهده گفتگو',
  noData: 'داده‌ای یافت نشد',
  agentPageTitle: 'جزئیات دستیار',
  agentPageDesc: 'مشاهده جزئیات کامل دستیار شخصی شما',
  inboxPageDesc: 'مشاهده پیام‌ها و نوتیفیکیشن‌های دریافتی شما',
  unansweredQuestionsDesc: 'مشاهده تمام سوالات پاسخ داده نشده کاربران و مدیریت آنها',
  PaymentResultTitle: 'صورت‌حساب',
  PaymentResultDescription:
    'نتیجه پرداخت شما با موفقیت ثبت شد. می‌توانید جزئیات کامل تراکنش را در این صفحه مشاهده کنید.',
  CheckoutResultTitle: 'نتیجه خرید اشتراک',
  CheckoutResultDescription: 'نتیجه پرداخت اشتراک شما ثبت شد. می‌توانید جزئیات کامل تراکنش را در این صفحه مشاهده کنید.',
  notEnoughBalance: 'موجودی کافی نیست',

  // Error Messages
  insufficientBalance: 'موجودی ناکافی',
  pleaseRechargeYourAccount: 'موجودی حساب شما کافی نیست. لطفاً برای ادامه استفاده از سرویس، حساب خود را شارژ کنید.',
  recharge: 'شارژ حساب',
  networkError: 'خطای شبکه',
  checkYourConnection: 'لطفاً اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.',
  errorOccurred: 'خطایی رخ داد',
  pleaseTryAgain: 'مشکلی پیش آمده است. لطفاً بعداً دوباره تلاش کنید.',

  //packages
  starterPlan: 'اشتراک شروع',
  growthPlan: 'اشتراک رشد',
  professionalPlan: 'اشتراک حرفه‌ای',
  starterPlanDesc: '۱,۰۰۰,۰۰۰ تومان',
  growthPlanDesc: 'با ۴,۵۰۰,۰۰۰ تومان شارژ حساب، ۵,۰۰۰,۰۰۰ تومان اعتبار بگیرید!',
  professionalPlanDesc: 'با ۸,۰۰۰,۰۰۰ تومان شارژ حساب، ۱۰,۰۰۰,۰۰۰ تومان اعتبار بگیرید!',
  starterPlanFeature1: 'دسترسی به تمام امکانات آینو',
  starterPlanFeature2: 'اعتبار قابل استفاده در Private RAG، Chatbot و Content Creator',
  starterPlanFeature3: 'مناسب برای تست، پروژه‌های کوچک یا تیم‌های تازه‌کار',
  growthPlanFeature1: 'دسترسی به تمام امکانات آینو',
  growthPlanFeature2: 'مناسب برای استفاده‌های تیمی',
  growthPlanFeature3: '۱۰٪ صرفه‌جویی نسبت به اشتراک شروع',
  professionalPlanFeature1: 'دسترسی به تمام امکانات آینو',
  professionalPlanFeature2: 'صرفه اقتصادی و پایداری استفاده',
  professionalPlanFeature3: 'مناسب پروژه‌های بزرگ و بلندمدت',

  // Error Handler
  accessDenied: 'دسترسی رد شد',
  noAccessToResource: 'شما اجازه دسترسی به این منبع را ندارید.',
  ok: 'باشه',
  close: 'بستن',

  seePlans: 'مشاهده اشتراک‌ها',
  notNow: 'الان نه',

  fileSizeExceeded: 'حداکثر حجم مجاز فایل ۱ مگابایت است.',
  invalidFile: 'نوع فایل انتخاب‌شده پشتیبانی نمی‌شود.'
}
